const checkAvailableToApprovalRequest = ({ approvalType, dataTotalRequest, isLoading, isChangeScheduleAvailable }) => {
  if (approvalType?.value === 2 || isLoading) return true;

  return (approvalType?.value === 1 && dataTotalRequest?.remaining > 0) || !isChangeScheduleAvailable;
};

export default checkAvailableToApprovalRequest;
